import PropTypes from 'prop-types';

import './index.less';

function Footer({ children }) {
  return <div className='layout__footer'>{children}</div>;
}

Footer.propTypes = {
  children: PropTypes.node,
};

export default Footer;
